const names = [
// --- 33 English names ---
"John", "Mary", "James", "Linda", "Michael", "Patricia", "Robert",
  "Barbara", "William", "Elizabeth", "David", "Susan", "Joseph", "Jessica",
  "Charles", "Sarah", "Thomas", "Karen", "Christopher", "Nancy", "Daniel",
  "Lisa", "Matthew", "Betty", "Anthony", "Helen", "Mark", "Sandra",
  "Donald", "Carol", "Steven", "Ruth", "Andrew",

// --- 33 Italian names ---
"Luca", "Maria", "Marco", "Anna", "Francesco", "Giulia", "Giovanni",
  "Chiara", "Alessandro", "Sara", "Davide", "Martina", "Andrea", "Francesca",
  "Matteo", "Elena", "Simone", "Valentina", "Antonio", "Roberta", "Riccardo",
  "Federica", "Stefano", "Ilaria", "Federico", "Alessia", "Leonardo",
  "Beatrice", "Nicola", "Veronica", "Giorgio", "Serena", "Paolo",

//--- 33 German names ---
"Hans", "Anna", "Peter", "Ursula", "Jürgen", "Monika", "Wolfgang",
  "Andrea", "Thomas", "Ingrid", "Michael", "Heike", "Stefan", "Birgit",
  "Andreas", "Sabine", "Frank", "Petra", "Klaus", "Renate", "Helmut",
  "Gisela", "Manfred", "Karin", "Werner", "Brigitte", "Robert", "Eva",
  "Sven", "Julia", "Heinrich", "Claudia", "Johann",
];

const lastNames = [
  // --- 33 Italian last names ---
  "Rossi", "Russo", "Ferrari", "Esposito", "Bianchi",
  "Romano", "Colombo", "Ricci", "Marino", "Greco",
  "Bruno", "Gallo", "Conti", "De Luca", "Mancini",
  "Costa", "Giordano", "Rizzo", "Lombardi", "Moretti",
  "Barbieri", "Fontana", "Santoro", "Mariani", "Rinaldi",
  "Caruso", "Ferrara", "Galli", "Martini", "Leone",
  "Longo", "Sanna", "Messina",

  // --- 33 German last names ---
  "Müller", "Schmidt", "Schneider", "Fischer", "Weber",
  "Meyer", "Wagner", "Becker", "Schulz", "Hoffmann",
  "Schäfer", "Bauer", "Koch", "Richter", "Klein",
  "Wolf", "Schröder", "Neumann", "Braun", "Werner",
  "Schwarz", "Zimmermann", "Schmitz", "Krause", "Hartmann",
  "Lange", "Krüger", "Lehmann", "Schmid", "Beck",
  "Schubert", "Vogel", "Friedrich",

  // --- 33 English last names ---
  "Smith", "Johnson", "Williams", "Brown", "Jones",
  "Miller", "Davis", "Garcia", "Rodriguez", "Wilson",
  "Martinez", "Anderson", "Taylor", "Thomas", "Hernandez",
  "Moore", "Martin", "Jackson", "Thompson", "White",
  "Lopez", "Lee", "Gonzalez", "Harris", "Clark",
  "Lewis", "Robinson", "Walker", "Perez", "Hall",
  "Allen", "Young", "King"
];


const addresses = [
  // --- 33 Italian street addresses ---
  "Via Roma, 1",
  "Via Milano, 2",
  "Via Napoli, 3",
  "Via Garibaldi, 4",
  "Viale della Libertà, 5",
  "Piazza del Popolo, 6",
  "Via Dante, 7",
  "Via Mazzini, 8",
  "Corso Vittorio Emanuele, 9",
  "Via Torino, 10",
  "Viale Marconi, 11",
  "Via Verdi, 12",
  "Piazza Duomo, 13",
  "Via Giulia, 14",
  "Via Manzoni, 15",
  "Piazza San Marco, 16",
  "Viale dei Pini, 17",
  "Via dei Mille, 18",
  "Piazza Garibaldi, 19",
  "Via Cavour, 20",
  "Viale Dante Alighieri, 21",
  "Corso Re Umberto, 22",
  "Via Trieste, 23",
  "Via Genova, 24",
  "Via di Porta Angelica, 25",
  "Via del Corso, 26",
  "Viale Regina Elena, 27",
  "Corso Magenta, 28",
  "Via Crispi, 29",
  "Via Vittorio Veneto, 30",
  "Viale Amendola, 31",
  "Via Calzaiuoli, 32",
  "Piazza Navona, 33",

  // --- 33 German street addresses ---
  "Hauptstraße 1",
  "Bahnhofstraße 2",
  "Mühlenweg 3",
  "Marktplatz 4",
  "Schillerstraße 5",
  "Goethestraße 6",
  "Poststraße 7",
  "Rathausplatz 8",
  "Gartenweg 9",
  "Kirchstraße 10",
  "Berliner Allee 11",
  "Lindenstraße 12",
  "Wagnerweg 13",
  "Friedrichstraße 14",
  "Dorfstraße 15",
  "Brunnenweg 16",
  "Waldstraße 17",
  "Ringstraße 18",
  "Parkweg 19",
  "Mozartstraße 20",
  "Hafenstraße 21",
  "Lessingstraße 22",
  "Rosenweg 23",
  "Blumenstraße 24",
  "Rheinstraße 25",
  "Altstadtplatz 26",
  "Wiesenweg 27",
  "Bismarckstraße 28",
  "Theodor-Heuss-Ring 29",
  "Kaiserstraße 30",
  "Uhlandstraße 31",
  "Kastanienallee 32",
  "Schlossplatz 33",

  // --- 33 English street addresses ---
  "Main Street, 1",
  "High Street, 2",
  "Broadway, 3",
  "Elm Street, 4",
  "Maple Avenue, 5",
  "Oak Road, 6",
  "Pine Lane, 7",
  "Cedar Drive, 8",
  "Willow Court, 9",
  "Church Street, 10",
  "King Street, 11",
  "Queen Street, 12",
  "Park Avenue, 13",
  "Sunset Boulevard, 14",
  "Baker Street, 15",
  "Victoria Road, 16",
  "Oxford Street, 17",
  "Regent Street, 18",
  "Bond Street, 19",
  "Fleet Street, 20",
  "George Street, 21",
  "Princess Avenue, 22",
  "Mill Lane, 23",
  "Garden Lane, 24",
  "River Road, 25",
  "Hilltop Drive, 26",
  "Meadow Lane, 27",
  "Lakeview Road, 28",
  "Valley Road, 29",
  "South Street, 30",
  "North Avenue, 31",
  "West Lane, 32",
  "East Road, 33"
];

const companyNames = [
  // --- 33 Italian company names ---
  "Bianchi & Rossi S.p.A.",
  "Caruso S.r.l.",
  "Ferraro Innovations S.r.l.",
  "Del Mare & Figli S.p.A.",
  "Tranquilli Servizi S.r.l.",
  "Verdi Future Tech S.p.A.",
  "Giordano & Co. S.r.l.",
  "Marinelli Progetti S.r.l.",
  "Lombardi Group S.p.A.",
  "Costa Alimentari S.r.l.",
  "Ravelli Trading S.p.A.",
  "De Santis Energia S.r.l.",
  "Neri Ingegneria S.r.l.",
  "Capri Logistics S.p.A.",
  "Serafini & Partners S.r.l.",
  "Albani Consulting S.r.l.",
  "Orlando Ventures S.p.A.",
  "Santoro Food S.r.l.",
  "Rinaldi Furniture S.r.l.",
  "Mancini Vision Tech S.r.l.",
  "Calabresi Creative S.r.l.",
  "Vitalini Gruppo S.p.A.",
  "Colombo Export S.r.l.",
  "Esposito Design S.r.l.",
  "Corradi Automotive S.p.A.",
  "Rubino Moda S.p.A.",
  "Marcelli Innovazione S.r.l.",
  "Farina & Figli S.r.l.",
  "Cremona Biotech S.p.A.",
  "Scalise Costruzioni S.r.l.",
  "Bonavita Distribuzione S.r.l.",
  "Cellini Artigiani S.r.l.",
  "Ferrari e Fabbri S.p.A.",

  // --- 33 German company names ---
  "Müller GmbH",
  "Schmidt & Co. KG",
  "Wagner Solutions AG",
  "Bauer Logistik GmbH",
  "Fischer Industrie KG",
  "Weber Technik GmbH",
  "Klein Energie AG",
  "Schulz Media GmbH",
  "Schneider & Partner GmbH",
  "Vogel Maschinenbau AG",
  "Lange Handels KG",
  "Neumann IT GmbH",
  "Schäfer Gesundheit GmbH",
  "Braun Chemie AG",
  "Krüger Druckerei GmbH",
  "Lehmann Online KG",
  "Richter Transport GmbH",
  "Hoffmann & Sohn GmbH",
  "Becker Kommunikation AG",
  "Werner Elektrotechnik GmbH",
  "Wolf Immobilien KG",
  "Schwarz Finanzberatung GmbH",
  "Kaiser Wellness GmbH",
  "Linden Consulting AG",
  "Zimmermann Solutions GmbH",
  "Wendt Pharma KG",
  "Friedrich & Meier GmbH",
  "Krause Werbung GmbH",
  "Schubert Automobile AG",
  "Hartmann Glas KG",
  "Schmidt Gebäudeservice GmbH",
  "Lechner Bio AG",
  "Rosenberg Ventures GmbH",

  // --- 33 English company names ---
  "Smith & Co. Ltd",
  "Johnson Holdings Plc",
  "Brown Industries Inc.",
  "Jones & Sons Ltd",
  "Miller Enterprises LLC",
  "Davis Tech Solutions Inc.",
  "Garcia & Partners LLP",
  "Rodriguez Finance Ltd",
  "Wilson Creative Agency LLC",
  "Martinez Advisory Group Inc.",
  "Anderson Manufacturing Ltd",
  "Taylor Innovate Plc",
  "Thomas & Brown Consulting LLC",
  "Hernandez Retail Ltd",
  "Moore Health Systems Inc.",
  "Martin Logistics LLC",
  "Jackson Security Ltd",
  "Thompson Interiors Inc.",
  "White & Evans Associates LLP",
  "Lopez Global Solutions Inc.",
  "Lee Marketing Ltd",
  "Gonzalez & Blake Co. LLC",
  "Harris Automotive Plc",
  "Clark E-Commerce Inc.",
  "Lewis Software Solutions LLC",
  "Robinson Consulting Group Ltd",
  "Walker Foods Inc.",
  "Perez Telecom Plc",
  "Hall Renewable Energy Inc.",
  "Allen & Wright Security LLC",
  "Young Architecture Ltd",
  "King Publishing Inc.",
  "Greenwood Investments LLP"
];


const taxNumbers = [
  // --- 33 Italian tax numbers (IT + 11 digits) ---
  "IT27490130618",
  "IT38452196680",
  "IT91607215837",
  "IT10384557086",
  "IT77432410195",
  "IT66074598231",
  "IT85329140652",
  "IT75961423088",
  "IT99254100837",
  "IT24574357373",
  "IT54830782860",
  "IT16504219569",
  "IT37835907811",
  "IT06619244799",
  "IT98934025116",
  "IT31785456001",
  "IT12059677141",
  "IT50838975494",
  "IT19044839011",
  "IT74569903426",
  "IT47393027544",
  "IT06788045192",
  "IT89172403650",
  "IT03067042952",
  "IT31572964870",
  "IT50941028631",
  "IT66129474581",
  "IT23650211834",
  "IT37464841966",
  "IT02607518039",
  "IT70491023558",
  "IT18345602609",
  "IT94426531086",

  // --- 33 German tax numbers (DE + 9 digits) ---
  "DE185326904",
  "DE203597411",
  "DE195038727",
  "DE918573460",
  "DE470531892",
  "DE362807915",
  "DE792114638",
  "DE652739018",
  "DE486170529",
  "DE709831465",
  "DE104356792",
  "DE211859470",
  "DE534917286",
  "DE609380147",
  "DE838125794",
  "DE352097614",
  "DE713409528",
  "DE286351790",
  "DE194285607",
  "DE870936421",
  "DE401682795",
  "DE639127508",
  "DE289401365",
  "DE550813492",
  "DE718290536",
  "DE469213805",
  "DE319857402",
  "DE780425139",
  "DE943210658",
  "DE162547890",
  "DE235184976",
  "DE501938462",
  "DE629784310",

  // --- 33 English tax numbers (GB + 9 digits) ---
  "GB943167028",
  "GB501286497",
  "GB612945370",
  "GB098125463",
  "GB215394607",
  "GB847513209",
  "GB734601952",
  "GB325860971",
  "GB109743682",
  "GB469185320",
  "GB825917346",
  "GB593012764",
  "GB413869025",
  "GB570342819",
  "GB207436159",
  "GB184320965",
  "GB926501834",
  "GB235761409",
  "GB691254073",
  "GB137406289",
  "GB524813976",
  "GB812690543",
  "GB309458761",
  "GB648239105",
  "GB952784613",
  "GB173205498",
  "GB304159827",
  "GB745190236",
  "GB593480712",
  "GB260915384",
  "GB186430527",
  "GB042561973",
  "GB379501286"
];

const vatNumbers = [
  // --- 33 Italian VAT numbers (IT + 11 digits) ---
  "IT87209168542",
  "IT51976302861",
  "IT34262815904",
  "IT75143908625",
  "IT60483129750",
  "IT29754360891",
  "IT48039617522",
  "IT36025049781",
  "IT59314720698",
  "IT72690581432",
  "IT04159368720",
  "IT91256043806",
  "IT12673948022",
  "IT25349170658",
  "IT84196235040",
  "IT70735961824",
  "IT58923476105",
  "IT96412578031",
  "IT47035691287",
  "IT60182739514",
  "IT07369084136",
  "IT83345190267",
  "IT34708526190",
  "IT19836045217",
  "IT45230986751",
  "IT68093124507",
  "IT53049786214",
  "IT08956371420",
  "IT94532017866",
  "IT31069872459",
  "IT16790328544",
  "IT72965014830",
  "IT23871650490",

  // --- 33 German VAT numbers (DE + 9 digits) ---
  "DE903471625",
  "DE187346259",
  "DE762549130",
  "DE294156870",
  "DE645230918",
  "DE561803742",
  "DE458370216",
  "DE283907165",
  "DE807234519",
  "DE379015628",
  "DE905736418",
  "DE613529740",
  "DE732045619",
  "DE159386472",
  "DE520438691",
  "DE863019742",
  "DE416952380",
  "DE973405168",
  "DE854720316",
  "DE347680529",
  "DE109247685",
  "DE650921473",
  "DE731450289",
  "DE542371690",
  "DE804156932",
  "DE985301267",
  "DE201546398",
  "DE462389750",
  "DE916754023",
  "DE308521467",
  "DE627498310",
  "DE795036421",
  "DE128679043",

  // --- 33 English VAT numbers (GB + 9 digits) ---
  "GB138047692",
  "GB945623107",
  "GB260871594",
  "GB501286374",
  "GB837469201",
  "GB730592864",
  "GB280413759",
  "GB912654038",
  "GB465730129",
  "GB570392648",
  "GB283410957",
  "GB603195842",
  "GB875102436",
  "GB340598217",
  "GB194607528",
  "GB406251139",
  "GB728153904",
  "GB952374610",
  "GB319584720",
  "GB781456902",
  "GB103947865",
  "GB547180239",
  "GB629483701",
  "GB214607359",
  "GB457928613",
  "GB806194732",
  "GB709836415",
  "GB130205974",
  "GB394286751",
  "GB645381027",
  "GB972410356",
  "GB580967143",
  "GB301874265"
];

const streetNames = [
  // --- 33 Italian street names ---
  "Via Leonardo",
  "Via Tintoretto",
  "Via Michelangelo",
  "Piazza Dante",
  "Viale degli Artisti",
  "Corso Imperatore",
  "Piazza Farnese",
  "Via del Plebiscito",
  "Via del Mercato",
  "Lungarno Vecchio",
  "Via Tornabuoni",
  "Vicolo dell'Orto",
  "Via Palatina",
  "Via dell'Angelo",
  "Piazza della Signoria",
  "Via Petrarca",
  "Via delle Rose",
  "Piazza Bellini",
  "Corso dei Fiori",
  "Via Boccaccio",
  "Via Ariosto",
  "Viale Barberini",
  "Via Santa Lucia",
  "Piazzale Michelangelo",
  "Viale Donatello",
  "Via del Campidoglio",
  "Piazza Degli Eroi",
  "Via Principe Amedeo",
  "Via Lorenzo Il Magnifico",
  "Via del Teatro",
  "Viale San Francesco",
  "Via delle Belle Arti",
  "Piazza di Spagna",

  // --- 33 German street names ---
  "Grabenstraße",
  "Kaiserplatz",
  "Burgweg",
  "Am Münster",
  "Neue Straße",
  "Gartenplatz",
  "Bachgasse",
  "Rosenring",
  "Schulweg",
  "Bahnhofplatz",
  "Hügelstraße",
  "Kirchweg",
  "Martin-Luther-Straße",
  "Königsallee",
  "Klingenweg",
  "Dresdnerstraße",
  "Jahnplatz",
  "Bachstraße",
  "Am Schloss",
  "Schubertweg",
  "Beethovenstraße",
  "Tannenweg",
  "Lindenweg",
  "Glockenstraße",
  "Kastanienweg",
  "An der Mauer",
  "Ringplatz",
  "Hohenzollernstraße",
  "Schlehenweg",
  "Friedenstraße",
  "Dorfring",
  "Hauptplatz",
  "Blumenring",

  // --- 33 English street names ---
  "Rose Avenue",
  "Oak Way",
  "Bridgewater Lane",
  "Stonegate Road",
  "Crescent Drive",
  "Heather Ridge",
  "Woodland Trail",
  "Albion Street",
  "Greenfield Lane",
  "Pleasant Road",
  "Longview Avenue",
  "Cedar Grove",
  "Greenwood Way",
  "Fairview Drive",
  "Bloomfield Drive",
  "Heritage Road",
  "Magnolia Street",
  "Old Mill Lane",
  "Cherry Court",
  "Eastwood Road",
  "Ivy Lane",
  "Redwood Place",
  "Aspen Drive",
  "Cypress Way",
  "Birch Street",
  "Eagle Road",
  "Foxcroft Lane",
  "Summerfield Drive",
  "Cobblestone Way",
  "Rolling Hills",
  "Whispering Pines",
  "Highlands Drive",
  "Waterford Lane"
];

const cities = [
  // --- 33 Italian cities ---
  "Rome",
  "Milan",
  "Naples",
  "Turin",
  "Palermo",
  "Genoa",
  "Bologna",
  "Florence",
  "Bari",
  "Catania",
  "Venice",
  "Verona",
  "Messina",
  "Padua",
  "Trieste",
  "Taranto",
  "Brescia",
  "Prato",
  "Modena",
  "Reggio Calabria",
  "Reggio Emilia",
  "Perugia",
  "Ravenna",
  "Livorno",
  "Rimini",
  "Ferrara",
  "Salerno",
  "Sassari",
  "Monza",
  "Bergamo",
  "Trento",
  "Vicenza",
  "Pisa",

  // --- 33 German cities ---
  "Berlin",
  "Hamburg",
  "Munich",
  "Cologne",
  "Frankfurt",
  "Stuttgart",
  "Düsseldorf",
  "Dortmund",
  "Essen",
  "Leipzig",
  "Bremen",
  "Dresden",
  "Hanover",
  "Nuremberg",
  "Duisburg",
  "Bochum",
  "Wuppertal",
  "Bielefeld",
  "Bonn",
  "Münster",
  "Karlsruhe",
  "Mannheim",
  "Augsburg",
  "Wiesbaden",
  "Gelsenkirchen",
  "Mönchengladbach",
  "Braunschweig",
  "Chemnitz",
  "Kiel",
  "Aachen",
  "Krefeld",
  "Lübeck",
  "Oberhausen",

  // --- 33 British cities (England, Scotland, Wales, Northern Ireland) ---
  "London",
  "Birmingham",
  "Manchester",
  "Leeds",
  "Liverpool",
  "Sheffield",
  "Bristol",
  "Leicester",
  "Edinburgh",
  "Glasgow",
  "Cardiff",
  "Newcastle upon Tyne",
  "Nottingham",
  "Belfast",
  "Southampton",
  "Portsmouth",
  "Brighton",
  "Plymouth",
  "Stoke-on-Trent",
  "Wolverhampton",
  "Swansea",
  "Aberdeen",
  "Dundee",
  "Coventry",
  "Reading",
  "Kingston upon Hull",
  "Bradford",
  "Derby",
  "Exeter",
  "Norwich",
  "Cambridge",
  "Oxford",
  "Canterbury"
];

const zipCodes = [
  // --- 33 Italian ZIP Codes (5-digit numeric) ---
  "00157",
  "01543",
  "08124",
  "10965",
  "21097",
  "27231",
  "30561",
  "35842",
  "40927",
  "48106",
  "51209",
  "52670",
  "54931",
  "60357",
  "62944",
  "67418",
  "70125",
  "72839",
  "75204",
  "80391",
  "82466",
  "85713",
  "87902",
  "90211",
  "92754",
  "94583",
  "95946",
  "97420",
  "98137",
  "98652",
  "99108",
  "99234",
  "99871",

  // --- 33 German ZIP Codes (5-digit numeric) ---
  "01028",
  "02561",
  "04892",
  "06731",
  "09153",
  "10439",
  "11608",
  "14567",
  "16745",
  "19204",
  "21359",
  "24508",
  "26105",
  "28271",
  "30958",
  "33016",
  "35602",
  "40213",
  "45106",
  "50297",
  "53781",
  "60318",
  "68121",
  "70543",
  "72780",
  "76810",
  "80337",
  "83049",
  "86732",
  "90411",
  "94437",
  "97524",
  "99782",

  // --- 33 UK Postcodes (approx. outward + inward code) ---
  "EC1A 1BB",
  "W1A 0AX",
  "M1 9EL",
  "B33 8TH",
  "CR2 6XH",
  "DN55 1PT",
  "LN1 1FE",
  "RH10 2RP",
  "FY8 1LW",
  "OX1 7HQ",
  "SW1A 2AA",
  "L1 8JQ",
  "G12 8QQ",
  "EH1 1TH",
  "BT1 2AA",
  "CF10 1DD",
  "WV1 1LD",
  "AB10 1BX",
  "KY16 8BP",
  "CV1 2EZ",
  "EX4 3LF",
  "LE1 1BD",
  "NG1 4DR",
  "BA1 3HZ",
  "BH1 1DY",
  "DD1 4BX",
  "SA1 3EQ",
  "ZE1 0ZX",
  "IV1 1FN",
  "LS1 4AJ",
  "NE1 3AF",
  "PH1 5UD",
  "PO1 3AX",
];


export const mockData = {
  names: names,
  lastNames: lastNames,
  addresses: addresses,
  companyNames: companyNames,
  taxNumbers: taxNumbers,
  vatNumbers: vatNumbers,
  streetNames: streetNames,
  cities: cities,
  zipCodes: zipCodes,
}
